import { Link } from "react-router-dom";

const AiContentGeneratorHero = () => {
  return (
    <>
      <div className="ail-hero-area pt-50">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-10">
              <div className="text-center">
                <h1 className="ail-hero-title text-black fs-72">
                  {/* Copywriting AI <br />
                  With a{" "} */}
                  <span className="ail-highlighted-text">
                  Graphic Designing
                  </span>
                </h1>
                <p className="ail-body-color fs-20 fch-55 mx-auto">
                Transform ideas into stunning visuals that captivate and communicate. From logos to marketing materials, our designs make your brand unforgettable!
                </p>
                <img
                  src="assets/img/ail_home/hero.png"
                  alt=""
                  className="ail-hero-img img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AiContentGeneratorHero;
